(() => {
  const root = document.querySelector(".event");
  if (!root) return;

  /* ===== header offset for PC sticky ===== */
  const setHeaderOffset = () => {
    const header = document.querySelector("sticky-header.header-wrapper");
    const h = header ? Math.ceil(header.getBoundingClientRect().height || 0) : 0;
    document.documentElement.style.setProperty("--site-header-offset", `${h}px`);
  };
  setHeaderOffset();
  window.addEventListener("resize", setHeaderOffset);

  const headerEl = document.querySelector("sticky-header.header-wrapper");
  if (headerEl && "ResizeObserver" in window) {
    const ro = new ResizeObserver(() => setHeaderOffset());
    ro.observe(headerEl);
  }

  const mqMobile = window.matchMedia("(max-width: 990px)");
  const isMobile = () => mqMobile.matches;

  const afterAdd = root.dataset.afterAdd || "checkout";

  /* ===== elements ===== */
  const step1 = root.querySelector("#step_1");
  const step2 = root.querySelector("#step_2");
  const step3 = root.querySelector("#step_3");
  const step4 = root.querySelector("#step_4");
  const step5 = root.querySelector("#step_5");

  const steps = { 1: step1, 2: step2, 3: step3, 4: step4, 5: step5 };

  const collectionsWrap = root.querySelector("[data-ef-collections]");
  const precautionsEl = root.querySelector("[data-ef-precautions]");
  const productGrids = root.querySelectorAll("[data-products-for]");
  const variantGrids = root.querySelectorAll("[data-variants-for]");

  const selectedCollection1 = root.querySelector("[data-ef-selected-collection]");
  const selectedProduct = root.querySelector("[data-ef-selected-product]");

  const summaryCollection = root.querySelector("[data-ef-summary-collection]"); // (あれば)
  const summaryProduct = root.querySelector("[data-ef-summary-product]");
  const summaryVariant = root.querySelector("[data-ef-summary-variant]");

  const buyBtn = root.querySelector("[data-ef-buy]");
  const errorEl = root.querySelector("[data-ef-error]");

  // qty selector (Step5)
  const qtyDec = root.querySelector("[data-ef-qty-dec]");
  const qtyInc = root.querySelector("[data-ef-qty-inc]");
  const qtyInput = root.querySelector("[data-ef-qty-input]");
  const step5BackBtn = root.querySelector('#step_5 [data-ef-back]');

  // modal + mobile CTA
  const modal = root.querySelector("[data-ef-modal]");
  const openBtn = root.querySelector("[data-ef-open]");
  const closeTargets = root.querySelectorAll("[data-ef-close]");

  /* ===== helpers ===== */
  const show = (el) => el && el.classList.remove("is-hidden");
  const hide = (el) => el && el.classList.add("is-hidden");

  const countEnabledCollections = () => {
    return getEnabledChoices(collectionsWrap, "[data-collection]").length;
  };

  const countEnabledProductsForSelectedCollection = () => {
    if (!state.collectionHandle) return 0;
    const grid = root.querySelector(`[data-products-for="${state.collectionHandle}"]`);
    return getEnabledChoices(grid, "[data-product]").length;
  };

  const countEnabledVariantsForSelectedProduct = () => {
    if (!state.productHandle) return 0;
    const grid = root.querySelector(`[data-variants-for="${state.productHandle}"]`);
    return getEnabledChoices(grid, "[data-variant]").length;
  };

  /**
   * n に戻ろうとしたとき、そのステップが1択ならさらに前のステップへ “巻き戻す”
   * 返り値：最終的に遷移すべきステップ番号
   */
  const resolveBackStep = (targetStep) => {
    let s = Number(targetStep);

    // Step4(時間)に戻る必要があるのは「バリアントが複数」のときだけ
    if (s === 4) {
      const vCount = countEnabledVariantsForSelectedProduct();
      if (vCount <= 1) s = 3;
    }

    // Step3(日付)に戻る必要があるのは「商品が複数」のときだけ
    if (s === 3) {
      const pCount = countEnabledProductsForSelectedCollection();
      if (pCount <= 1) s = 2;
    }

    // Step2(開催場所)に戻る必要があるのは「コレクションが複数」のときだけ
    if (s === 2) {
      const cCount = countEnabledCollections();
      if (cCount <= 1) s = 1;
    }

    return s;
  };

  /* ===== auto-advance (single option skip) ===== */
  const getEnabledChoices = (scopeEl, selector) => {
    if (!scopeEl) return [];
    return [...scopeEl.querySelectorAll(selector)].filter((el) => !el.disabled);
  };

  const updateBackTargetForStep5 = (productHandle) => {
    if (!step5BackBtn) return;
    const grid = root.querySelector(`[data-variants-for="${productHandle}"]`);
    const vars = getEnabledChoices(grid, "[data-variant]");
    step5BackBtn.dataset.efBack = vars.length === 1 ? "3" : "4";
  };

  // 無限ループ防止（同一状態で1回だけ）
  const autoGuard = {
    step2: false,
    step3ForCollection: new Set(),
    step4ForProduct: new Set()
  };

  const autoPickCollectionIfSingle = () => {
    if (autoGuard.step2) return;
    if (!collectionsWrap) return;

    const cols = getEnabledChoices(collectionsWrap, "[data-collection]");
    if (cols.length === 1) {
      autoGuard.step2 = true;
      // DOM切替直後のズレ防止で次tick
      setTimeout(() => cols[0].click(), 0);
    }
  };

  const autoPickProductIfSingle = (collectionHandle) => {
    if (!collectionHandle) return;
    if (autoGuard.step3ForCollection.has(collectionHandle)) return;

    const grid = root.querySelector(`[data-products-for="${collectionHandle}"]`);
    const prods = getEnabledChoices(grid, "[data-product]");
    if (prods.length === 1) {
      autoGuard.step3ForCollection.add(collectionHandle);
      setTimeout(() => prods[0].click(), 0);
    }
  };

  const finalizeSingleVariantIfOnlyOne = (productHandle) => {
    if (!productHandle) return;
    if (autoGuard.step4ForProduct.has(productHandle)) return;

    const grid = root.querySelector(`[data-variants-for="${productHandle}"]`);
    if (!grid) return;

    const vars = getEnabledChoices(grid, "[data-variant]");
    if (vars.length !== 1) return;

    updateBackTargetForStep5(productHandle);

    autoGuard.step4ForProduct.add(productHandle);

    const varBtn = vars[0];

    // クリックに頼らず、Variant select と同じ状態更新を直でやる
    state.variantId = varBtn.dataset.variant;
    state.variantTitle = varBtn.dataset.variantTitle || varBtn.textContent.trim();

    clearActive("[data-variant]");
    varBtn.classList.add("is-active");

    syncSummary();
    setQty(1);
    setBuyEnabled(true);
    goStep(5);
  };

  const setBuyEnabled = (enabled) => {
    if (!buyBtn) return;
    buyBtn.disabled = !enabled;
    buyBtn.classList.toggle("is-disabled", !enabled);
  };

  const clearActive = (selector) => {
    root.querySelectorAll(selector).forEach((el) => el.classList.remove("is-active"));
  };

  const state = {
    collectionHandle: null,
    collectionTitle: null,
    collectionPrecautionsHtml: "",
    productHandle: null,
    productTitle: null,
    variantId: null,
    variantTitle: null
  };

  const syncSummary = () => {
    if (summaryProduct) summaryProduct.textContent = state.productTitle || "—";
    if (summaryVariant) summaryVariant.textContent = state.variantTitle || "—";
  };

  const openProductsForCollection = (handle) => {
    productGrids.forEach((grid) => {
      grid.dataset.productsFor === handle ? show(grid) : hide(grid);
    });
  };

  const openVariantsForProduct = (handle) => {
    variantGrids.forEach((grid) => {
      grid.dataset.variantsFor === handle ? show(grid) : hide(grid);
    });
  };

  const resetFromStep = (stepNo) => {
    if (stepNo <= 2) {
      state.collectionPrecautionsHtml = "";
      renderPrecautions();
    }
    if (stepNo <= 3) {
      state.productHandle = null;
      state.productTitle = null;
      clearActive("[data-product]");
      productGrids.forEach(hide);
      if (selectedProduct) selectedProduct.textContent = "—";
    }
    if (stepNo <= 4) {
      state.variantId = null;
      state.variantTitle = null;
      clearActive("[data-variant]");
      variantGrids.forEach(hide);
    }
    if (stepNo <= 5) {
      setBuyEnabled(false);
      state.variantId = null;
      state.variantTitle = null;
      syncSummary();
    }
    if (errorEl) hide(errorEl);
  };

  const resetAll = () => {
    // state
    state.collectionHandle = null;
    state.collectionTitle = null;
    state.collectionPrecautionsHtml = "";
    state.productHandle = null;
    state.productTitle = null;
    state.variantId = null;
    state.variantTitle = null;

    // UI reset
    clearActive("[data-collection]");
    clearActive("[data-product]");
    clearActive("[data-variant]");

    productGrids.forEach(hide);
    variantGrids.forEach(hide);

    if (selectedCollection1) selectedCollection1.textContent = "—";
    if (selectedProduct) selectedProduct.textContent = "—";

    // precautions
    if (precautionsEl) {
      precautionsEl.innerHTML = "";
      precautionsEl.classList.add("is-hidden");
    }

    // buy
    setBuyEnabled(false);
    setQty(1);
    syncSummary();
    if (errorEl) hide(errorEl);

    // auto-advance guards reset（次回も自動スキップが効くように）
    autoGuard.step2 = false;
    autoGuard.step3ForCollection.clear();
    autoGuard.step4ForProduct.clear();
  };

  const renderPrecautions = () => {
    if (!precautionsEl) return;

    const html = state.collectionPrecautionsHtml || "";
    if (!html.trim()) {
      precautionsEl.innerHTML = "";
      precautionsEl.classList.add("is-hidden");
      return;
    }

    // data属性からescape済み文字列を戻す
    const decoded = html
      .replaceAll("&lt;", "<")
      .replaceAll("&gt;", ">")
      .replaceAll("&quot;", '"')
      .replaceAll("&#39;", "'")
      .replaceAll("&amp;", "&");

    precautionsEl.innerHTML = decoded;
    precautionsEl.classList.remove("is-hidden");
  };

  // qty
  const getQty = () => {
    const v = parseInt(qtyInput?.value || "1", 10);
    return Number.isFinite(v) && v > 0 ? v : 1;
  };
  const setQty = (v) => {
    if (!qtyInput) return;
    const n = Number.isFinite(v) && v > 0 ? v : 1;
    qtyInput.value = String(n);
  };

  const goStep = (n) => {
    Object.entries(steps).forEach(([k, el]) => {
      if (!el) return;
      Number(k) === Number(n) ? show(el) : hide(el);
    });

    // 「ページがじわじわ下にずれる」原因になるので、ページscrollIntoViewはしない。
    // 代わりにカード内部スクロールだけ先頭へ。
    const card = root.querySelector(".event-card");
    if (card) card.scrollTop = 0;
  };

  /* ===== modal ===== */
  const openModal = () => {
    if (!modal) return;
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    document.body.classList.add("ef-modal-open");

    // スマホは step2 から
    if (isMobile()) {
      if (!state.collectionHandle && !state.productHandle && !state.variantId) {
        resetFromStep(3);
        resetFromStep(4);
        resetFromStep(5);
      }
      goStep(2);
      autoPickCollectionIfSingle();
    }
  };

  const closeModal = () => {
    if (!modal) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ef-modal-open");
  };

  openBtn?.addEventListener("click", openModal);
  closeTargets.forEach((el) => el.addEventListener("click", closeModal));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal?.classList.contains("is-open")) closeModal();
  });

    /* ===== processing guard (bfcache/back) ===== */
  const buyDefaultText = buyBtn ? buyBtn.textContent.trim() : "購入する";

  const resetProcessingUI = () => {
    if (!buyBtn) return;
    buyBtn.textContent = buyDefaultText;
    buyBtn.disabled = true;
    buyBtn.classList.add("is-disabled");
    buyBtn.classList.remove("is-processing");
    if (errorEl) hide(errorEl);
    // 「処理中」の途中状態を残さない
    // 必要なら qty も戻す
    setQty(1);
  };

  const isBackForwardNav = () => {
    const nav = performance.getEntriesByType?.("navigation")?.[0];
    return nav && nav.type === "back_forward";
  };

  // checkout -> back で bfcache 復元された時にリセット
  window.addEventListener("pageshow", (e) => {
    if (e.persisted || isBackForwardNav()) {
      resetProcessingUI();
      closeModal();
      document.body.classList.remove("ef-modal-open");

      // ★autoGuard reset
      autoGuard.step2 = false;
      autoGuard.step3ForCollection.clear();
      autoGuard.step4ForProduct.clear();
    }
  });

  /* ===== init ===== */
  // PC: step1開始 / SP: モーダル開くまで何も見せない（step1はCSSで非表示）
  goStep(1);
  setBuyEnabled(false);
  setQty(1);
  syncSummary();

  qtyDec?.addEventListener("click", () => setQty(getQty() - 1));
  qtyInc?.addEventListener("click", () => setQty(getQty() + 1));
  qtyInput?.addEventListener("change", () => setQty(getQty()));

  /* ===== event delegation ===== */
  root.addEventListener("click", async (e) => {
    // Start (PCのstep1ボタン / SPのstep1は非表示だが押されてもOK)
    const start = e.target.closest("[data-ef-start]");
    if (start) {
      if (isMobile()) {
        openModal();
        return;
      }

      // いったん最初から（前回の選択が残ってても毎回同じ挙動に）
      resetAll();

      // Step2へ行く前に 1択か判定
      goStep(2);

      // コレ1なら選択
      const cCount = countEnabledCollections();
      if (cCount === 1) {
        autoPickCollectionIfSingle(); // click で state が入る

        // state が入るのは次tickなので、次tickで判定を続ける
        setTimeout(() => {
          const pCount = countEnabledProductsForSelectedCollection();
          if (pCount === 1) {
            autoPickProductIfSingle(state.collectionHandle);

            setTimeout(() => {
              const vCount = countEnabledVariantsForSelectedProduct();
              if (vCount === 1) {
                finalizeSingleVariantIfOnlyOne(state.productHandle); // Step5へ
              }
            }, 0);
          }
        }, 0);

        return;
      }

      // コレ複数なら普通にStep2
      autoPickCollectionIfSingle();
      return;
    }

    // Back
    const back = e.target.closest("[data-ef-back]");
    if (back) {
      let to = Number(back.dataset.efBack);
      to = resolveBackStep(to); // ★ここがキモ

      if (to === 1) {
        resetAll();
        goStep(1);
        return;
      }

      if (to === 2) {
        resetFromStep(3);
        goStep(2);
        autoPickCollectionIfSingle();
        return;
      }

      if (to === 3) {
        resetFromStep(3); // ★ここは 3 が正解（空画面対策）
        if (state.collectionHandle) openProductsForCollection(state.collectionHandle);
        goStep(3);
        autoPickProductIfSingle(state.collectionHandle);
        return;
      }

      if (to === 4) {
        // ※ここに来るのは「バリアント複数」のときだけになる
        setBuyEnabled(false);
        if (state.productHandle) openVariantsForProduct(state.productHandle);
        goStep(4);
        return;
      }
    }

    // Collection select
    const colBtn = e.target.closest("[data-collection]");
    if (colBtn && collectionsWrap?.contains(colBtn) && !colBtn.disabled) {
      state.collectionHandle = colBtn.dataset.collection;
      state.collectionTitle = colBtn.dataset.collectionTitle || colBtn.textContent.trim();
      state.collectionPrecautionsHtml = colBtn.dataset.collectionPrecautions || "";
      renderPrecautions();

      clearActive("[data-collection]");
      colBtn.classList.add("is-active");

      if (selectedCollection1) selectedCollection1.textContent = state.collectionTitle;
      if (summaryCollection) summaryCollection.textContent = state.collectionTitle;

      resetFromStep(3);
      openProductsForCollection(state.collectionHandle);
      goStep(3);
      autoPickProductIfSingle(state.collectionHandle);
      return;
    }

    // Product select
    const prodBtn = e.target.closest("[data-product]");
    if (prodBtn && !prodBtn.disabled) {
      state.productHandle = prodBtn.dataset.product;
      state.productTitle = prodBtn.dataset.productTitle || prodBtn.textContent.trim();

      updateBackTargetForStep5(state.productHandle);

      clearActive("[data-product]");
      prodBtn.classList.add("is-active");

      if (selectedProduct) selectedProduct.textContent = state.productTitle;

      // Step5 summary
      syncSummary();

      resetFromStep(4);
      openVariantsForProduct(state.productHandle);
      goStep(4);
      finalizeSingleVariantIfOnlyOne(state.productHandle);
      return;
    }

    // Variant select
    const varBtn = e.target.closest("[data-variant]");
    if (varBtn && !varBtn.disabled) {
      state.variantId = varBtn.dataset.variant;
      state.variantTitle = varBtn.dataset.variantTitle || varBtn.textContent.trim();

      clearActive("[data-variant]");
      varBtn.classList.add("is-active");

      syncSummary();

      setQty(1);
      setBuyEnabled(true);
      goStep(5);
      return;
    }

    // Buy
    const buy = e.target.closest("[data-ef-buy]");
    if (buy && !buy.disabled) {
      if (!state.variantId) return;

      setBuyEnabled(false);
      if (errorEl) hide(errorEl);

      const prev = buy.textContent;
      buy.textContent = "処理中...";

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
          body: new URLSearchParams({
            id: state.variantId,
            quantity: String(getQty())
          }).toString()
        });

        if (!res.ok) throw new Error("add failed");
        window.location.href = afterAdd === "cart" ? "/cart" : "/checkout";
      } catch (err) {
        if (errorEl) show(errorEl);
        setBuyEnabled(true);
        buy.textContent = prev;
      }
    }
  });
})();
